"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.saveScheduledEmailHandler = void 0;
var tslib_1 = require("tslib");
var effects_1 = require("redux-saga/effects");
var sdk_model_1 = require("@gooddata/sdk-model");
var scheduledEmail_1 = require("../../events/scheduledEmail");
function saveScheduledEmail(ctx, scheduledEmail, filterContextRef) {
    var backend = ctx.backend, workspace = ctx.workspace;
    if (!sdk_model_1.isObjRef(scheduledEmail)) {
        throw new Error("Cannot save schedule not referencing to an persisted object");
    }
    return backend
        .workspace(workspace)
        .dashboards()
        .updateScheduledMail(scheduledEmail, scheduledEmail, filterContextRef);
}
function saveScheduledEmailHandler(ctx, cmd) {
    var _a, scheduledEmail, filterContextRef;
    return tslib_1.__generator(this, function (_b) {
        switch (_b.label) {
            case 0:
                _a = cmd.payload, scheduledEmail = _a.scheduledEmail, filterContextRef = _a.filterContextRef;
                return [4 /*yield*/, effects_1.call(saveScheduledEmail, ctx, scheduledEmail, filterContextRef)];
            case 1:
                _b.sent();
                return [2 /*return*/, scheduledEmail_1.scheduledEmailSaved(ctx, cmd.correlationId)];
        }
    });
}
exports.saveScheduledEmailHandler = saveScheduledEmailHandler;
//# sourceMappingURL=saveScheduledEmailHandler.js.map